import React from "react";
import StrawberryMilk from "../../assets/MelonaMilkNutritionImages/StrawberryMilkIcon.png";

function StrawberryMilkNutritionalInfo() {
  return (
    <div className="flex flex-col items-center justify-center px-4 pb-20 mb-10 -mt-10 sm:px-8 md:px-16 z-70">
      {/* Set a maximum width for the component */}
      <div className="w-full max-w-screen-xl mx-auto rounded-lg">
        <div className="flex flex-col items-center justify-center md:flex-row">
          {/* StrawberryMilk Image */}
          <div className="">
            <img
              src={StrawberryMilk}
              alt="Food Product"
              className="w-64 h-auto ml-6 -ml-10 md:mr-52 lg:-ml-0"
            />
          </div>
          {/* Description */}
          <div className="">
            <h2 className="text-xl font-semibold text-black ">DESCRIPTION</h2>
            <div className="h-1 my-2 bg-red-300"></div>
            <p className="mb-4 text-lg text-black ">
              Savour the sweetness of summer with our Strawberry Flavoured Milk.
              Let the lusciousness of ripe strawberries intertwine with the
              smooth embrace of milk, creating a harmony of flavours that is
              both refreshing and delightful. It's like taking a stroll through
              a strawberry patch with every sip.
            </p>
          </div>
        </div>
        {/* Ingredients */}
        <div className="mb-4">
          <h2 className="text-xl font-semibold text-black">INGREDIENTS</h2>
          <div className="h-1 my-2 bg-red-300"></div>
          <p className="mb-10 text-lg text-black">
            Milk, Water, Sugar, Skim Milk Powder, Whey Powder, Strawberry Juice
            Concentrate, Artificial Flavor, Emulsifier (Mono-and Diglycerides),
            Stabilizers (Carrageenan, Guar Gum), Colors (Allura Red AC,
            Brilliant Blue FCF)
            <br></br>
            <br></br>
            <span className="font-bold">Contains:</span> Milk
          </p>
        </div>
        {/* Nutritional Information */}
        <div className="mb-4 md:hidden">
          <h2 className="text-xl font-semibold text-black">NUTRITIONAL</h2>
          <div className="h-1 my-2 bg-red-300"></div>
          <div className="grid grid-cols-2 gap-1">
            <div className="font-semibold text-black">Serving Size</div>
            <div className="text-right text-black">1 Carton (200ml)</div>
            <div className="font-semibold text-black">Calories</div>
            <div className="text-right text-black">160</div>
            <div className="font-semibold text-black">Total Fat</div>
            <div className="text-right text-black">6 g</div>
            <div className="font-semibold text-black">Saturated Fat</div>
            <div className="text-right text-black">3.5 g</div>
            <div className="font-semibold text-black">Trans Fat</div>
            <div className="text-right text-black">0 g</div>
            <div className="font-semibold text-black">Cholesterol</div>
            <div className="text-right text-black">20 mg</div>
            <div className="font-semibold text-black">Sodium</div>
            <div className="text-right text-black">85 mg</div>
            <div className="font-semibold text-black">Total Carbohydrate</div>
            <div className="text-right text-black">22 g</div>
            <div className="font-semibold text-black">Sugars</div>
            <div className="text-right text-black">21 g</div>
            <div className="font-semibold text-black">Protein</div>
            <div className="text-right text-black">5 g</div>
            <div className="font-semibold text-black">Vitamin D</div>
            <div className="text-right text-black">0 g</div>
            <div className="font-semibold text-black">Potassium</div>
            <div className="text-right text-black">230 mg</div>
            <div className="font-semibold text-black">Calcium</div>
            <div className="text-right text-black">180 mg</div>
            <p className="font-semibold text-black">Iron</p>
            <p className="text-right text-black">0 mg</p>
          </div>
        </div>

        <div className="hidden md:block">
          <h2 className="text-xl font-semibold text-black">NUTRITIONAL</h2>
          <div className="h-1 my-2 bg-red-300"></div>
          <div className="grid grid-cols-4 gap-1">
            <div>
              <div className="font-semibold text-black">Serving Size</div>
              <div className="font-semibold text-black">Calories</div>
              <div className="font-semibold text-black">Total Fat</div>
              <div className="font-semibold text-black">Saturated Fat</div>
              <div className="font-semibold text-black">Trans Fat</div>
              <div className="font-semibold text-black">Cholesterol</div>
              <div className="font-semibold text-black">Sodium</div>
            </div>
            <div className="md:mr-5 lg:mr-20">
              <div className="text-right text-black">1 Carton (200ml)</div>
              <div className="text-right text-black">160</div>
              <div className="text-right text-black">6 g</div>
              <div className="text-right text-black">3.5 g</div>
              <div className="text-right text-black">0 g</div>
              <div className="text-right text-black">20 mg</div>
              <div className="text-right text-black">85 mg</div>
            </div>
            <div className="md:ml-5 lg:mr-20">
              <div className="font-semibold text-black">Total Carbohydrate</div>
              <div className="font-semibold text-black">Sugars</div>
              <div className="font-semibold text-black">Protein</div>
              <div className="font-semibold text-black">Vitamin D</div>
              <div className="font-semibold text-black">Potassium</div>
              <div className="font-semibold text-black">Calcium</div>
              <div className="font-semibold text-black">Iron</div>
            </div>
            <div>
              <div className="text-right text-black">22 g</div>
              <div className="text-right text-black">21 g</div>
              <div className="text-right text-black">5 g</div>
              <div className="text-right text-black">0 g</div>
              <div className="text-right text-black">230 mg</div>
              <div className="text-right text-black">180 mg</div>
              <div className="text-right text-black">0 mg</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StrawberryMilkNutritionalInfo;
